export default {
  // UEDITOR_HOME_URL: 'http://localhost:8081/public/lib/UEditor/',
  UEDITOR_HOME_URL: "/lib/UEditor/",
  // 编辑器不自动被内容撑高
  autoHeightEnabled: false,
  // 初始容器高度
  initialFrameHeight: 240,
  // 初始容器宽度
  initialFrameWidth: '100%',
  // 关闭自动保存
  enableAutoSave: false
};